import { render } from "./Bitcoin.vue?vue&type=template&id=890b2e24&ts=true"
import script from "./Bitcoin.vue?vue&type=script&lang=ts"
export * from "./Bitcoin.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__